import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, CircularProgress, Alert } from '@mui/material';
import { useAuthStore } from '../stores/authStore';

export function AuthCallbackPage() {
  const navigate = useNavigate();
  const { checkSession } = useAuthStore();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // better-auth handles the OAuth token exchange server-side via cookie.
    // We just need to refresh the session state and redirect.
    checkSession()
      .then(() => {
        navigate('/dashboard', { replace: true });
      })
      .catch(() => {
        setError('Authentication failed. Please try again.');
      });
  }, [checkSession, navigate]);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      {error ? (
        <Alert severity="error">{error}</Alert>
      ) : (
        <>
          <CircularProgress />
          <Typography>Completing sign in...</Typography>
        </>
      )}
    </Box>
  );
}
